module.exports = __webpack_public_path__ + "img/we_deliver.159de91f.png";